import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { ResponsiveEmbed, IFrame } from 'components'

import './codepen.scss'

class Codepen extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	render() {
		const {
			attributes,
			width,
			height,
			theme,
			tab,
			node: { data },
		} = this.props

		const author = data.get('author')
		const hash = data.get('hash')
		const src = `//codepen.io/${author}/embed/${hash}/?height=${height.replace(
			'px',
			''
		)}&theme-id=${theme}&default-tab=${tab}`
		const userLink = `http://codepen.io/${author}`
		const pen = `${author}/pen/${hash}/`
		const title = `http://codepen.io/${author} (${hash})`

		return (
			<div {...attributes} className={`c-codepen${attributes.className}`}>
				<ResponsiveEmbed>
					<IFrame
						width={width}
						title={title}
						height={height}
						src={src}
						style={{ height, width }}
					>
						<a href={pen}>See this pen</a> by {author} (
						<a href={userLink}>@{author}</a>) on{' '}
						<a href="http://codepen.io">CodePen</a>.
					</IFrame>
				</ResponsiveEmbed>
			</div>
		)
	}
}

Codepen.propTypes = {
	author: PropTypes.string,
	hash: PropTypes.string,
	height: PropTypes.string,
	width: PropTypes.string,
	tab: PropTypes.oneOf(['html', 'css', 'result', 'js']),
	theme: PropTypes.string,
}

Codepen.defaultProps = {
	author: null,
	hash: null,
	height: '600px',
	width: '100%',
	tab: 'result',
	theme: '0',
}

export default Codepen
